export const NotificationActions = {
  ACTION_ALL: 'all-actions', // Doesn't exist on backend
  ACTION_TAG: 'tagged-you-in-a-comment',
  ACTION_LIKE: 'liked-a-comment',
  ACTION_REPLY: 'replied-to-a-comment',
  ACTION_NEW_COMMENT: 'made-a-comment',
  ACTION_ADDED_CONTENT: 'added-content',
  ACTION_EDITED_CONTENT: 'edited-content',
  ACTION_BADGE_ISSUED: 'issued-you-a-badge',
  ACTION_CERTIFICATE_ISSUED: 'issued-you-a-certificate',
  ACTION_CERTIFICATE_REFRESHED: 'refreshed-your-certificate-appearance',
  ACTION_LIKE_POST: 'liked-a-post',
  ACTION_NEW_POST: 'made-a-post',
  ACTION_NEW_SINGLE_POST: 'new-post',
};
